module.exports = __webpack_public_path__ + "img/GD.65373a44.svg";